import Rating, {RatingProps} from '@mui/material/Rating';
import {styled} from '@mui/material/styles';

export const CRating = styled(Rating)<RatingProps>(
  (/* { theme } */) => ({
  }),
);
